import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const PhilippinesLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_EAST_ASIA,
  CODE: 'PH',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Philippines',
  SHORT_NAME: 'PH',

  DISPLAY_NAME: 'Philippines (English)',
  DISPLAY_COUNTRY: 'Philippines',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 12.8797,
    INITIAL_LONGITUDE: 121.774,
    INITIAL_ZOOM: 4,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/ph/en/',

  MAP_URL: 'https://www.uniqlo.com/ph/shop/',
  // MAP_MOBILE_URL: '',

  TERMS_OF_USE_URL:
    'https://faq-ph.uniqlo.com/articles/en_US/FAQ/Terms-of-use/',
  PRIVACY_POLICY_URL:
    'https://faq-ph.uniqlo.com/articles/en_US/FAQ/Privacy-Policy/',
  CONTACT_US_URL: 'https://faq-ph.uniqlo.com/',

  POSTCODE_FORMAT: /[0-9]{4}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default PhilippinesLocale
